<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title>
      <v-tab  v-for="tab of tabs"  :key="tab.id" @click="WarnUser(tab.to)"
      :id="`mtgTransSequenceTab${tab.id}`"
      :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'MortgageTax',
  components: {
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/mtg/transactions' }, caption: 'Mortgage Tax' },
      { id: 2, to: { path: '/mtg/browse/receivedof' }, caption: 'Browse' },
      { id: 3, to: { path: '/mtg/reports' }, caption: 'Reports' },
      { id: 4, to: { path: '/mtg/utils/createfiscalyear' }, caption: 'Utils' },
    ],
  }),
  methods: {
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  computed: {
  },
};
</script>
